"use strict";

import React from 'react';

import { ItemClassInfoResolver } from 'api/assetAPICall';
import { _I_, defineSimpleTerm } from 'components/locs';
import ApplicationEvents from 'components/applicationEvents';
import { IconFontAwesome } from 'generics/icons';


////////////////////////////////////////////
// single line of textual description
class ItemClassDescLineText extends React.Component  {
  render()  {
    const  {  color,  value, type="text"  } = this.props.desc||{};
    if ( type != "text" )
      return null
    const styles = color? { "color": `#${color}`} : null;
    return  <div  className="type-text"  style={styles}  >{`${value}`}</div>
  }

  static filter(it)  {
    return ((it.type||"text") == "text") && (!!it.value);
  }
};


////////////////////////////////////////////
// single line of textual description
class ItemClassDescBundleText extends React.Component  {
  render()  {
    const  {  color,  value, type="text"  } = this.props.desc||{};
    if ( type != "dropped_bundle" )
      return null
    const styles = color? { "color": `#${color}`} : null;
    return  <div  className="type-dropped_bundle"  style={styles}  >{`${value}`}</div>
  }

  static filter(it)  {
    return ((it.type||"text") == "dropped_bundle") && (!!it.value);
  }
};


////////////////////////////////////////////
// single entry of dropped_item type desc
class ItemClassDescLineDroppedItem extends React.Component  {
  constructor( props )  {
    super( props );

    this.state = {
      "stage": "unknown",
      "classInfo" : {},
    };
  }


  componentWillMount()  {
    this.checkClass();
  }


  componentWillReceiveProps( nextProps )  {
    if ( this.props.desc != nextProps.desc )
      this.checkClass();
  }


  checkClass()  {
    const  {  type="text",  value,  } = this.props.desc||{};
    const  assetclass = (value||{})["class"];
    if ((type == "dropped_item")&&(assetclass))  {
        const {  appid  } = this.props;
        ItemClassInfoResolver.resolve(  appid, assetclass
                               ).then(  classInfo  =>  this.setState({ classInfo, "stage":"done" })
                              ).catch(  reason  =>  this.setState({ "stage":"unknown" })
                              )

        this.setState({"stage":"pending",  classInfo:{} });
        return
    }
    this.setState({"stage":"unknown",  classInfo:{}});
  }


  render()  {
    const  {  classInfo,  stage  } = this.state;
    if ( stage == "done" )  {
      const  {  name_color,  icon_url,  name,  market_hash_name  } = classInfo||{};
      const {  appid  } = this.props;
      const clickHandler = ()=> ApplicationEvents.emit_async( "market.setCurrentAssetByHash", appid, market_hash_name );

      const iconStyles = name_color? { "borderColor": `#${name_color}`} : null;
      return  <div  className="type-dropped_item"  title={`${name}`}  >
                <div className="hover-icon"  style={iconStyles}  >
                  <img  src={icon_url||"./images/bag_random.png"} />
                </div>
                <div  className="item-name"  onClick={clickHandler}  >
                  <IconFontAwesome type="search" size="2x"  fixedWidth />
                </div>
              </div>

    }

    if ( !this.props.showUnresolved )
      return null;

    // unresolveds - invalid or pending
    return  <div  className="type-dropped_item" title={_I_(`ClassInfoDescriptions.dropped_item.stage-${stage}`)}>
              <div className="hover-icon"  >
                  <img  src="./images/bag_random.png" />
              </div>
            </div>
  }

  static filter(it)  {
    return ((it.type||"text") == "dropped_item") && (!!it.value) && (!!it.value["class"]);
  }
};


const TYPE_COMPONENTS  =  {
  "text":             ItemClassDescLineText,
  "dropped_item":     ItemClassDescLineDroppedItem,
  "dropped_bundle":   ItemClassDescBundleText,
};


// List of various descriptions of some type
export class ClassInfoDescriptions extends React.Component  {
  render()  {
    const {  appid,  type,  descriptions,  owner_descriptions  } = this.props;
    const DescComponent = TYPE_COMPONENTS[type];
    if (!DescComponent)  {
      return null
    }

    const entries = (descriptions && descriptions.length) ? descriptions : owner_descriptions;
    const content = (entries||[]).filter( DescComponent.filter );
    if ( !content.length )  {
      return null
    }

    return <div className={`assetDescriptions type-${type}`} >
      <div className="label" >{_I_(`ClassInfoDescriptions.${type}.block_label`)}</div>
      <div className="descBlock">
        {content.map(
            (desc, key)  =>  <DescComponent  key={key}  desc={desc}  appid={appid}  />
          )}
      </div>
    </div>;
  }
};


defineSimpleTerm( "ClassInfoDescriptions.dropped_item.block_label", "Contains:", {
  "en_US": "Contains one of the following:",
  "ru_RU": "Содержит один из:",
  "cs_CZ": "Contains one of the following:",
  "fr_FR": "Contient l'un des items suivants:",
  "de_DE": "Enthält eines der Folgenden:",
  "it_IT": "Contiene uno dei seguenti:",
  "ko_KR": "다음 내용을 포함",
  "pl_PL": "Zawiera jeden z następujących:",
  "pt_PT": "Contains one of the following:",
  "es_ES": "Contiene uno de los siguiente:",
  "zh_CN": "包含以下任意之一：",
  "zh_TW": "包含以下任意之一："
});


defineSimpleTerm( "ClassInfoDescriptions.dropped_item.stage-unknown", "Unknown", {
  "en_US": "Unknown",
  "ru_RU": "Неизвестно",
  "cs_CZ": "Unknown",
  "fr_FR": "Inconnu",
  "de_DE": "Unbekannt",
  "it_IT": "Sconosciuto",
  "ko_KR": "알 수 없음",
  "pl_PL": "Nieznany",
  "pt_PT": "Unknown",
  "es_ES": "Desconocido",
  "zh_CN": "未知",
  "zh_TW": "未知"
});


defineSimpleTerm( "ClassInfoDescriptions.dropped_item.stage-done", "", {});


defineSimpleTerm( "ClassInfoDescriptions.dropped_item.stage-pending", "...loading", {
  "en_US": "...loading",
  "ru_RU": "...загружается",
  "cs_CZ": "...loading",
  "fr_FR": "...chargement",
  "de_DE": "...wird geladen",
  "it_IT": "...caricamento",
  "ko_KR": "...불러오는 중",
  "pl_PL": "...ładowanie",
  "pt_PT": "...loading",
  "es_ES": "...cargando",
  "zh_CN": "…加载中",
  "zh_TW": "…加載中"
});


defineSimpleTerm( "ClassInfoDescriptions.text.block_label", "", {});


defineSimpleTerm( "ClassInfoDescriptions.dropped_bundle.block_label", "Can contain:", {
  "en_US": "Can contain:",
  "ru_RU": "Может содержать:",
  "cs_CZ": "Can contain:",
  "fr_FR": "Peut contenir:",
  "de_DE": "Kann beinhalten:",
  "it_IT": "Può contenere:",
  "ko_KR": "다음을 포함하고 있습니다:",
  "pl_PL": "Może zawierać:",
  "pt_PT": "Can contain:",
  "es_ES": "Puede contener:",
  "zh_CN": "可能包含：",
  "zh_TW": "可能包含："
});

